export default {
  nav: {
    home: 'Startseite',
    shoppingGuide: 'Einkaufsführer',
    categories: 'Kategorien',
    guides: 'Ratgeber',
    review: 'Bewertung',
    shipping: 'Versand',
    safety: 'Sicherheit',
    articles: 'Artikel',
    cta: 'Jetzt kaufen',
  },
  footer: {
    disclaimerTitle: 'Wichtiger Haftungsausschluss',
    disclaimer: 'Dies ist eine unabhängige Ressourcen-Website und steht in keiner Verbindung zu AllChinaBuy oder einer verwandten Plattform. Alle Marken gehören ihren jeweiligen Eigentümern.',
    safety: 'Sicherheit',
    privacy: 'Datenschutz',
    terms: 'Bedingungen',
    about: 'Über uns',
    copyright: 'Alle Rechte vorbehalten.',
  },
  notFound: {
    title: 'Seite nicht gefunden',
    subtitle: 'Die gesuchte Seite existiert nicht.',
    backHome: 'Zurück zur Startseite',
  },
};